import { render, staticRenderFns } from "./AudioElementSettings.vue?vue&type=template&id=58fc8cb4&scoped=true&"
import script from "./AudioElementSettings.vue?vue&type=script&lang=ts&"
export * from "./AudioElementSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fc8cb4",
  null
  
)

export default component.exports